<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h1>College Preferences</h1>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <ul class="preferences_main">
                                            <li v-for="cs in preferences_list">
                                                <div class="preferences-list">
                                                    <div class="preferences-description">
                                                        {{cs.title}}
                                                    </div>
                                                    <label class="checker">
                                                        <input class="checkbox" type="checkbox" v-bind:name="cs.setting"
                                                               @change="updatePreferences($event)"
                                                               v-bind:data-key="cs.college_settings_enc_id"
                                                               v-if="cs.value == 1"/>
                                                        <input class="checkbox" type="checkbox" v-bind:name="cs.setting"
                                                               @change="updatePreferences($event)"
                                                               v-bind:data-key="cs.college_settings_enc_id"
                                                               v-else-if="cs.value == 2" checked/>
                                                        <div class="check-bg"></div>
                                                        <div class="checkmark">
                                                            <svg viewBox="0 0 100 100">
                                                                <path d="M20,55 L40,75 L77,27" fill="none" stroke="#FFF"
                                                                      stroke-width="15" stroke-linecap="round"
                                                                      stroke-linejoin="round"/>
                                                            </svg>
                                                        </div>
                                                    </label>
                                                </div>
                                            </li>
                                            <div id="loading-list">
                                                <div class="loading-list"></div>
                                                <div class="loading-list-ring"></div>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
    import collegeBanner from './../../components/collegeBanner.vue'
    import axios from 'axios';
    import toastr from  '../../../public/js/toastr.js';
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data: function () {
            return {
                preferences_list: '',
            }
        },
        mounted() {
            var t = this;
            var url = this.$store.getters.getDomain;

            //api request for new jobs
            axios({
                method: 'POST',
                url: `${url}api/v2/college-index/get-college-preferences`,
                headers: requestHeaders(),
            }).then(function (res) {
                t.preferences_list = res['data']['response']['data'];
                var fadeTarget = document.getElementById("loading-list");
                fadeTarget.style.display = "none";
            }).catch(function (error) {
                // console.log(error)
            })
        },
        methods: {
            updatePreferences: function (event) {
                var fadeTarget = document.getElementById("loading-list");
                fadeTarget.style.display = "block";
                var t = this;
                var element = event.currentTarget;
                var title = element.parentElement.parentElement.textContent;
                var data_key = element.getAttribute('data-key');
                var data_name = element.getAttribute('name');
                if (event.target.checked) {
                    t.settingUpdate(data_key, 2, title, element,data_name);
                } else {
                    t.settingUpdate(data_key, 1, title, element,data_name);
                }
            },
            settingUpdate(data_key, type, title, element,name) {
                var t = this;
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-index/update-college-preferences`, {
                    college_settings_enc_id: data_key,
                    value: type,
                    name:name,
                }, {
                    headers: requestHeaders()
                }).then(function (response) {
                    var fadeTarget = document.getElementById("loading-list");
                    fadeTarget.style.display = "none";
                    if (response['data']['response']['status'] == 200) {
                        if (type == 1) {
                            toastr.warning(title + ' Off', 'Success');
                            t.$store.getters.getPreferences[name] = false;
                        } else {
                            t.$store.getters.getPreferences[name] = true;
                            toastr.success(title + ' On', 'Success');
                        }
                    } else {
                        if (element.checked == true) {
                            element.checked = false;
                        } else {
                            element.checked = true;
                        }
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                })
            },
        }
    }
</script>

<style scoped>
    ul.preferences_main {
        min-height: 120px;
        position: relative;
    }
    ul.preferences_main li {
        list-style: none;
        border-bottom: 1px solid #9999;
    }

    ul.preferences_main li .preferences-list {
        padding: 20px;
    }

    ul.preferences_main li .preferences-list .preferences-description {
        display: inline-block;
        font-size: 15px;
        width: calc(100% - 90px);
    }

    .checker {
        display: inline-block;
        font-size: 20vmin;
        margin-top: -10px;
        height: 20px;
        width: 50px;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        padding: 8px 12px;
        -webkit-transition: -webkit-transform .4s ease;
        transition: -webkit-transform .4s ease;
        transition: transform .4s ease;
        transition: transform .4s ease, -webkit-transform .4s ease;
        cursor: pointer;
        float: right;
    }

    .checkmark {
        width: 21px;
        height: 21px;
        -webkit-transition: -webkit-transform .4s ease;
        transition: -webkit-transform .4s ease;
        transition: transform .4s ease;
        transition: transform .4s ease, -webkit-transform .4s ease;
        -webkit-transform: translateX(-0.4em);
        transform: translateX(-0.4em);
        z-index: 5;
    }

    .checkmark svg {
        display: block;
        background: #e5e5e5;
        -webkit-transform: translateX(0.4em);
        transform: translateX(0.4em);
        border-radius: 7px;
        -webkit-transition: background-color .4s ease, -webkit-transform calc(.4s * 1.5) ease;
        transition: background-color .4s ease, -webkit-transform calc(.4s * 1.5) ease;
        transition: background-color .4s ease, transform calc(.4s * 1.5) ease;
        transition: background-color .4s ease, transform calc(.4s * 1.5) ease, -webkit-transform calc(.4s * 1.5) ease;
    }

    .checkmark svg path {
        stroke-dasharray: 90 90;
        stroke-dashoffset: 90;
        -webkit-transition: stroke-dashoffset calc(.4s / 3) linear calc(.4s / 3);
        transition: stroke-dashoffset calc(.4s / 3) linear calc(.4s / 3);
    }

    .checkbox {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.4;
        visibility: hidden;
    }

    .checkbox:checked ~ .checkmark {
        -webkit-transform: translate(60px);
        transform: translate(60px);
    }

    .checkbox:checked ~ .checkmark svg {
        background: #00a0e3;
        -webkit-transform: translate(-30px);
        transform: translate(-30px);
    }

    .checkbox:checked ~ .checkmark svg path {
        stroke-dashoffset: 0;
    }

    .check-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        background: white;
        z-index: 2;
    }

    .check-bg:before, .check-bg:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border-radius: 15px;
    }

    .check-bg:after {
        background: white;
    }

    .check-bg:before {
        -webkit-transition: -webkit-transform .4s ease;
        transition: -webkit-transform .4s ease;
        transition: transform .4s ease;
        transition: transform .4s ease, -webkit-transform .4s ease;
        -webkit-transform: translateY(10%);
        transform: translateY(10%);
        -webkit-transform-origin: bottom center;
        transform-origin: bottom center;
        background: black;
        -webkit-filter: blur(0.10em);
        filter: blur(0.10em);
        opacity: 0.2;
        z-index: -1;
    }

    .checker.checker:active {
        -webkit-transform: scale(0.85);
        transform: scale(0.85);
        -webkit-transition-duration: calc(.4s / 2);
        transition-duration: calc(.4s / 2);
    }

    .checker.checker:active .check-bg::before {
        -webkit-transform: translateY(0) scale(0.8);
        transform: translateY(0) scale(0.8);
        opacity: 0.2;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
        position: relative;
    }
    #loading-list {
        display: block;
        position: unset;
    }
    .loading-list-ring{
        position: absolute;
    }
    .loading-list {
        position: absolute;
        top: 0;
        background-color: transparent;
        z-index: 99;
    }

</style>